import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.main`
  flex: 1;
  padding: 6rem 2rem 3rem;
  background: white;
`;

export const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  font-size: 3rem;
  font-weight: 800;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const FAQItem = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  margin-bottom: 1rem;
  overflow: hidden;
`;

export const Question = styled.button`
  width: 100%;
  text-align: left;
  padding: 1.5rem;
  background: none;
  border: none;
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c3e50;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    background: #e9ecef;
  }
`;

export const Answer = styled.div<{ $isOpen: boolean }>`
  max-height: ${(props) => (props.$isOpen ? "1000px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease;
  padding: ${(props) => (props.$isOpen ? "0 1.5rem 1.5rem" : "0 1.5rem")};
  color: #4a5568;
  line-height: 1.8;
`;

export const Category = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 3rem 0 1.5rem;
`;

